// extracted by mini-css-extract-plugin
export default {"provider":"CampaignAutomationPage-module__provider--nbrcM","page":"CampaignAutomationPage-module__page--S00PZ","mainContent":"CampaignAutomationPage-module__mainContent--zB88h"};